import SidebarBookingsRepliesIndexRoute from 'uplisting-frontend/pods/-sidebar/bookings/replies/index/route';

export default class ProtectionOverviewBookingsRepliesIndexRoute extends SidebarBookingsRepliesIndexRoute {
  parentRoute = 'protection.overview.bookings';
}
